import { request } from "../../utils/config"

export const GET_WAREHOUSES = async (params) => {
  const response = await request({
    url: `Warehouses`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_WAREHOUSES = async (params) => {
  const response = await request({
    url: `Warehouses`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  await localStorage.setItem(
    "warehouses",
    JSON.stringify(response.data.data.reverse())
  )
  return response.data
}

export const GET_WAREHOUSE = async (id: string) => {
  const response = await request({
    url: `Warehouses/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_SELECTED_WAREHOUSE = async () => {
  const response = await request({
    url: `Warehouses/GetSelected`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
